import { createSelector } from '@ngrx/store';

import { ValidationResponse } from '@models/swagger';
import { State } from './reducer';
import { selectValidateVertiRelationsState } from '../selectors';

export const getData = createSelector(selectValidateVertiRelationsState, (state: State) => state.data);

export const getError = createSelector(selectValidateVertiRelationsState, (state: State) => state.error);

export const getLoading = createSelector(selectValidateVertiRelationsState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: ValidationResponse) => T) =>
  createSelector(selectValidateVertiRelationsState, (state: State) => fn(state.data));
